import { RouterType } from '@online-webinar/router';
import { WebinarSecurity } from '@online-webinar/webinar-management';
import { authGuard } from '../integrations/auth-guard';

export const updateRoute = (router: RouterType) => {
    router.routesById['/$webinarId/security'].update({
        staticData: { title: { page: 'OptionMenu.Security', forWebinar: true } },
        component: authGuard(WebinarSecurity, { canBroadcast: true })
    });
};
